<template>
    <div>
        <b-modal ref="detectModal" centered hide-footer>
            <template #modal-header>
                <div class="header-container">
                    <div style="display: flex; align-items: center;">
                        <span class="header-title">{{ "이상 범위 판단 기준" }}</span>
                    </div>
                    <span class="header-close-btn" @click="hide"><i class="fa fa-times"></i></span>
                </div>
            </template>
            <div class="table-responsive" v-if="detectParam">
                <table class="table table-bordered table-sm">
                    <thead class="thead-light">
                        <tr class="text-center">
                            <th>{{ "지표" }}</th>
                            <th>{{ "값" }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center" v-for="(key, index) in Object.keys(detectParam)" :key="index">
                            <td>{{ key }}</td>
                            <td>{{ detectParam[key] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        detectParam: { type: Object, default: () => {} },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        show() {
            this.$refs.detectModal.show();
        },
        hide() {
            this.$refs.detectModal.hide();
        },
    },
};
</script>

<style scoped>
.header-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-title {
    font-size: 14px;
    font-weight: 600;
    margin-right: 20px;
}
.header-close-btn {
    cursor: pointer;
    font-size: 14px;
}
</style>
